import { TestIdsComponents } from '#app/shared/components/TestIdsComponents'
import { LinearProgress } from '@mui/material'
import { memo } from 'react'

export default memo(function Loading() {
  return <LinearProgress data-testid={TestIdsComponents.LoadingIndicator} />
})
